import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { SearchResultsStore } from 'stores/search-results-store';
import { PlaybackFilterPill } from './playback-filter-pill';
import { RouteStore } from 'bernie-core';

export interface PlaybackFilterProps {
  searchResults?: SearchResultsStore;
  routeStore?: RouteStore;
  analytics?: any;
}

@inject('searchResults', 'routeStore', 'analytics')
@observer
export class PlaybackFilter extends React.Component<PlaybackFilterProps, {}> {
  public render() {
    const { routeStore, analytics, searchResults } = this.props;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const isLoading = searchResults && searchResults.isLoading;
    const pills = sortAndFilter && sortAndFilter.pills;

    let playbackPills = null;

    if (pills) {
      playbackPills = pills.map(pill => (
        <PlaybackFilterPill
          key={`playback-filter-${pill.name}-${pill.value}`}
          pill={pill}
          disabled={isLoading}
          routeStore={routeStore}
          analytics={analytics}
        />
      ));
    }

    return (
      <section className="uitk-scroll-horizontal uitk-flex all-b-padding-three all-t-padding-three playback-pill-grid">
        {playbackPills}
      </section>
    );
  }
}
